import React from "react";
import { Link } from "react-router-dom";

function OurBranches() {
  return (
    <section className="branchWrapper py-100">
      <div className="container">
        <div className="row">
          <div className="col-12 mb-5">
            <h2 className="titleMain">OUR BRANCHES</h2>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6 col-12 mb-4">
            <div className="branchAddressBox">
              <div
                className="branchImg"
                data-bs-toggle="modal"
                data-bs-target="#imgGallery1"
              >
                <img src="/assets/images/center-img1.webp" alt="" />
              </div>
              <div className="branchBody">
                <h2>AHMEDABAD</h2>
                <div className="addressMain">
                  <p>Surfaces Plus</p>
                  <p>210, One 42 - Retail Plaza, Opposite Dishman </p>
                  <p>House, Behind Ambli - Bopal Road, Ashok Vatika, </p>
                  <p>Ahmedabad, Gujarat 380058.</p>
                </div>
                <div className="contactMain">
                  <p>
                    <Link to={"tel:+917575001191"}>
                      <i className="fa fa-phone me-1"></i> +91 757 500 1191
                    </Link>
                  </p>
                  <p>
                    <a href="mailto:waltzahd@jbglass.in">
                      <i className="fa fa-envelope me-1"></i>{" "}
                      waltzahd@jbglass.in
                    </a>
                  </p>
                  <p className="mt-3">
                    <Link
                      to={"https://bit.ly/Waltz_Ahmedabad"}
                      target="_blank"
                      style={{ color: "#0b44ef", textDecoration: "none" }}
                    >
                      <i className="fa fa-map-marker me-1"></i> Click For Map
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-sm-6 col-12 mb-4">
            <div className="branchAddressBox">
              <div
                className="branchImg"
                data-bs-toggle="modal"
                data-bs-target="#imgGallery2"
              >
                <img src="/assets/images/center-img2.webp" alt="" />
              </div>
              <div className="branchBody">
                <h2>BENGALURU</h2>
                <div className="addressMain">
                  <p>Aaren Intpro</p>
                  <p>Plot No. 342/8, Mysore Road, NTY Layout, </p>
                  <p>Bengaluru </p>
                </div>
                <div className="contactMain">
                  <p>
                    <Link to={"tel:+918884464411"}>
                      <i className="fa fa-phone me-1"></i> +91 888 446 4411
                    </Link>
                  </p>
                  <p>
                    <a href="mailto:waltz@aarenintpro.com">
                      <i className="fa fa-envelope me-1"></i>{" "}
                      waltz@aarenintpro.com
                    </a>
                  </p>
                  <p className="mt-3">
                    <Link
                      to={
                        "https://www.google.com/maps/place/AAREN+INTPRO/@12.9552407,77.5397462,17z/data=!3m1!4b1!4m6!3m5!1s0x3bae3e0dde119581:0x66f104a2c0fa658b!8m2!3d12.9552407!4d77.5446118!16s%2Fg%2F11c1qrvx5l?entry=ttu&g_ep=EgoyMDI0MTAxNi4wIKXMDSoASAFQAw%3D%3D"
                      }
                      target="_blank"
                      style={{ color: "#0b44ef", textDecoration: "none" }}
                    >
                      <i className="fa fa-map-marker me-1"></i> Click For Map
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-sm-6 col-12 mb-4">
            <div className="branchAddressBox">
              <div
                className="branchImg"
                data-bs-toggle="modal"
                data-bs-target="#imgGallery3"
              >
                <img src="/assets/images/center-img3.webp" alt="" />
              </div>
              <div className="branchBody">
                <h2>HYDERABAD</h2>
                <div className="addressMain">
                  <p>Waltz Hyderabad</p>
                  <p>Second Floor, Road No. 12, Above Stanley Level </p>
                  <p>Next, Bhavani Nagar, Banjara Hills, Hyderabad, </p>
                  <p>Telangana 500034</p>
                </div>
                <div className="contactMain">
                  <p>
                    <Link to={"tel:+919819849893"}>
                      <i className="fa fa-phone me-1"></i> +91 981 984 9893
                    </Link>
                  </p>
                  <p>
                    <a href="mailto:hyderabad@jbglass.in">
                      <i className="fa fa-envelope me-1"></i>{" "}
                      hyderabad@jbglass.in
                    </a>
                  </p>
                  <p className="mt-3">
                    <Link
                      to={"https://bit.ly/Waltz_Hyderabad"}
                      target="_blank"
                      style={{ color: "#0b44ef", textDecoration: "none" }}
                    >
                      <i className="fa fa-map-marker me-1"></i> Click For Map
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-sm-6 col-12 mb-4">
            <div className="branchAddressBox">
              <div
                className="branchImg"
                data-bs-toggle="modal"
                data-bs-target="#imgGallery4"
              >
                <img src="/assets/images/center-img4.webp" alt="" />
              </div>
              <div className="branchBody">
                <h2>JAIPUR</h2>
                <div className="addressMain">
                  <p>Badayas Kitchen</p>
                  <p>263, Shree Gopal Nagar, Gopal Pura Bypass, </p>
                  <p>Jaipur - 302018</p>
                </div>
                <div className="contactMain">
                  <p>
                    <Link to={"tel:+919829055008"}>
                      <i className="fa fa-phone me-1"></i> +91 982 905 5008
                    </Link>
                  </p>
                  <p>
                    <a href="mailto:waltzjaipur@jbglass.in">
                      <i className="fa fa-envelope me-1"></i>{" "}
                      waltzjaipur@jbglass.in
                    </a>
                  </p>
                  <p className="mt-3">
                    <Link
                      to={
                        "https://www.google.com/maps/place/Badayas+Kitchen/@26.8799364,75.7729355,17z/data=!3m1!4b1!4m6!3m5!1s0x396db56f454b0041:0x2260252bdd86fe7f!8m2!3d26.8799364!4d75.7755158!16s%2Fg%2F11f9tw6mzp?entry=ttu&g_ep=EgoyMDI0MTAxNi4wIKXMDSoASAFQAw%3D%3D"
                      }
                      target="_blank"
                      style={{ color: "#0b44ef", textDecoration: "none" }}
                    >
                      <i className="fa fa-map-marker me-1"></i> Click For Map
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-sm-6 col-12 mb-4">
            <div className="branchAddressBox">
              <div
                className="branchImg"
                data-bs-toggle="modal"
                data-bs-target="#imgGallery5"
              >
                <img src="/assets/images/center-img5.webp" alt="" />
              </div>
              <div className="branchBody">
                <h2>MUMBAI</h2>
                <div className="addressMain">
                  <p>Om Interiors</p>
                  <p>Excel Garment, Veer Nariman Marg,</p>
                  <p>Worli, Mumbai</p>
                </div>
                <div className="contactMain">
                  <p>
                    <Link to={"tel:+919820211262"}>
                      <i className="fa fa-phone me-1"></i> +91 982 021 1262
                    </Link>
                  </p>
                  <p>
                    <a href="mailto:mumbai@jbglass.in">
                      <i className="fa fa-envelope me-1"></i> mumbai@jbglass.in
                    </a>
                  </p>
                  <p className="mt-3">
                    <Link
                      to={"https://bit.ly/Waltz_Mumbai"}
                      target="_blank"
                      style={{ color: "#0b44ef", textDecoration: "none" }}
                    >
                      <i className="fa fa-map-marker me-1"></i> Click For Map
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-sm-6 col-12 mb-4">
            <div className="branchAddressBox">
              <div
                className="branchImg"
                data-bs-toggle="modal"
                data-bs-target="#imgGallery6"
              >
                <img src="/assets/images/center-img6.webp" alt="" />
              </div>
              <div className="branchBody">
                <h2>SURAT</h2>
                <div className="addressMain">
                  <p>Prabhu Surat Buildware Pvt. Ltd</p>
                  <p>83-Suruchi Society, Ghod Dod Rd, </p>
                  <p>Athwa, Surat</p>
                </div>
                <div className="contactMain">
                  <p>
                    <Link to={"tel:+919824144670"}>
                      <i className="fa fa-phone me-1"></i> +91 982 414 4670
                    </Link>
                  </p>
                  <p>
                    <a href="mailto:waltzsurat@jbglass.in">
                      <i className="fa fa-envelope me-1"></i>{" "}
                      waltzsurat@jbglass.in
                    </a>
                  </p>
                  <p className="mt-3">
                    <Link
                      to={
                        "https://www.google.com/maps/place/PrabhuSurat+BuildWares+Private+Limited/@21.1728432,72.8102975,17z/data=!3m1!4b1!4m6!3m5!1s0x3be04e0ce36d4cb9:0x68382a5254ae9447!8m2!3d21.1728432!4d72.8128778!16s%2Fg%2F1q62dfz7y?entry=ttu&g_ep=EgoyMDI0MTAxNi4wIKXMDSoASAFQAw%3D%3D"
                      }
                      target="_blank"
                      style={{ color: "#0b44ef", textDecoration: "none" }}
                    >
                      <i className="fa fa-map-marker me-1"></i> Click For Map
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="imgGallery1"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg imgGallery-modal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                AHMEDABAD
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div
                id="carouselExample1"
                className="carousel slide"
                data-bs-ride="carousel"
              >
                <div className="carousel-inner">
                  <div className="carousel-item active">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/AHMEDABAD/Image 1.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/AHMEDABAD/Image 2.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/AHMEDABAD/Image 3.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/AHMEDABAD/Image 4.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/AHMEDABAD/Image 5.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/AHMEDABAD/Image 6.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/AHMEDABAD/Image 7.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/AHMEDABAD/Image 8.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/AHMEDABAD/Image 9.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/AHMEDABAD/Image 10.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/AHMEDABAD/Image 11.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/AHMEDABAD/Image 12.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/AHMEDABAD/Image 13.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/AHMEDABAD/Image 14.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/AHMEDABAD/Image 15.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/AHMEDABAD/Image 16.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/AHMEDABAD/Image 17.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/AHMEDABAD/Image 18.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/AHMEDABAD/Image 19.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/AHMEDABAD/Image 20.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/AHMEDABAD/Image 21.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/AHMEDABAD/Image 22.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/AHMEDABAD/Image 23.webp" alt="" />
                    </div>
                  </div>
                </div>
                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target="#carouselExample1"
                  data-bs-slide="prev"
                >
                  <span
                    className="carousel-control-prev-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">Previous</span>
                </button>
                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target="#carouselExample1"
                  data-bs-slide="next"
                >
                  <span
                    className="carousel-control-next-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">Next</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="imgGallery2"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg imgGallery-modal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                BENGALURU
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div
                id="carouselExample2"
                className="carousel slide"
                data-bs-ride="carousel"
              >
                <div className="carousel-inner">
                  <div className="carousel-item active">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/BENGALURU/Image 1.webp" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="imgGallery3"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg imgGallery-modal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                HYDERABAD
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div
                id="carouselExample3"
                className="carousel slide"
                data-bs-ride="carousel"
              >
                <div className="carousel-inner">
                  <div className="carousel-item active">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/HYDERABAD/Image 1.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/HYDERABAD/Image 2.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/HYDERABAD/Image 3.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/HYDERABAD/Image 4.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/HYDERABAD/Image 5.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/HYDERABAD/Image 6.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/HYDERABAD/Image 7.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/HYDERABAD/Image 8.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/HYDERABAD/Image 9.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/HYDERABAD/Image 10.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/HYDERABAD/Image 11.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/HYDERABAD/Image 12.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/HYDERABAD/Image 13.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/HYDERABAD/Image 14.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/HYDERABAD/Image 15.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/HYDERABAD/Image 16.webp" alt="" />
                    </div>
                  </div>
                </div>
                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target="#carouselExample3"
                  data-bs-slide="prev"
                >
                  <span
                    className="carousel-control-prev-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">Previous</span>
                </button>
                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target="#carouselExample3"
                  data-bs-slide="next"
                >
                  <span
                    className="carousel-control-next-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">Next</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="imgGallery4"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg imgGallery-modal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                JAIPUR
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div
                id="carouselExample4"
                className="carousel slide"
                data-bs-ride="carousel"
              >
                <div className="carousel-inner">
                  <div className="carousel-item active">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/JAIPUR/Image 1.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/JAIPUR/Image 2.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/JAIPUR/Image 3.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/JAIPUR/Image 4.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/JAIPUR/Image 5.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/JAIPUR/Image 6.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/JAIPUR/Image 7.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/JAIPUR/Image 8.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/JAIPUR/Image 9.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/JAIPUR/Image 10.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/JAIPUR/Image 11.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/JAIPUR/Image 12.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/JAIPUR/Image 13.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/JAIPUR/Image 14.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/JAIPUR/Image 15.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/JAIPUR/Image 16.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/JAIPUR/Image 17.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/JAIPUR/Image 18.webp" alt="" />
                    </div>
                  </div>
                </div>
                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target="#carouselExample4"
                  data-bs-slide="prev"
                >
                  <span
                    className="carousel-control-prev-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">Previous</span>
                </button>
                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target="#carouselExample4"
                  data-bs-slide="next"
                >
                  <span
                    className="carousel-control-next-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">Next</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="imgGallery5"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg imgGallery-modal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                MUMBAI
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div
                id="carouselExample5"
                className="carousel slide"
                data-bs-ride="carousel"
              >
                <div className="carousel-inner">
                  <div className="carousel-item active">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/MUMBAI/Image 1.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/MUMBAI/Image 2.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/MUMBAI/Image 3.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/MUMBAI/Image 4.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/MUMBAI/Image 5.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/MUMBAI/Image 6.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/MUMBAI/Image 7.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/MUMBAI/Image 8.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/MUMBAI/Image 9.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/MUMBAI/Image 10.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/MUMBAI/Image 11.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/MUMBAI/Image 12.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/MUMBAI/Image 13.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/MUMBAI/Image 14.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/MUMBAI/Image 15.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/MUMBAI/Image 16.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/MUMBAI/Image 17.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/MUMBAI/Image 18.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/MUMBAI/Image 19.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/MUMBAI/Image 20.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/MUMBAI/Image 21.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/MUMBAI/Image 22.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/MUMBAI/Image 23.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/MUMBAI/Image 24.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/MUMBAI/Image 25.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/MUMBAI/Image 26.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/MUMBAI/Image 27.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/MUMBAI/Image 28.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/MUMBAI/Image 29.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/MUMBAI/Image 30.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/MUMBAI/Image 31.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/MUMBAI/Image 32.webp" alt="" />
                    </div>
                  </div>
                </div>
                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target="#carouselExample5"
                  data-bs-slide="prev"
                >
                  <span
                    className="carousel-control-prev-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">Previous</span>
                </button>
                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target="#carouselExample5"
                  data-bs-slide="next"
                >
                  <span
                    className="carousel-control-next-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">Next</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="imgGallery6"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg imgGallery-modal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                SURAT
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div
                id="carouselExample6"
                className="carousel slide"
                data-bs-ride="carousel"
              >
                <div className="carousel-inner">
                  <div className="carousel-item active">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/SURAT/Image 1.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/SURAT/Image 2.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/SURAT/Image 3.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/SURAT/Image 4.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/SURAT/Image 5.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/SURAT/Image 6.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/SURAT/Image 7.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/SURAT/Image 8.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/SURAT/Image 9.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/SURAT/Image 10.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/SURAT/Image 11.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/SURAT/Image 12.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/SURAT/Image 13.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/SURAT/Image 14.webp" alt="" />
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="imgGalleryHldr">
                      <img src="assets/images/SURAT/Image 15.webp" alt="" />
                    </div>
                  </div>
                </div>
                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target="#carouselExample6"
                  data-bs-slide="prev"
                >
                  <span
                    className="carousel-control-prev-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">Previous</span>
                </button>
                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target="#carouselExample6"
                  data-bs-slide="next"
                >
                  <span
                    className="carousel-control-next-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">Next</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default OurBranches;
